/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

import { Link } from "react-router-dom";
import { AppBar } from "./NavegacioBarEstils";

export function NavBar({ link = "/" }) {
  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed">
        <Toolbar>
          <Link to={link}>
            <img src="logo_Generalitat.png" className="logoHeader" alt="Generalitat de Catalunya"></img>
          </Link>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1, p: 5 }}></Box>
    </Box>
  );
}
